module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerloi01",
      "epub:type": "frontmatter",
      "id": "loi"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerloi01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page x. ",
      "epub:type": "pagebreak",
      "id": "px",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page xi. ",
      "epub:type": "pagebreak",
      "id": "pxi",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiFischerOA0007#toc"
    }
  }, [_vm._v("Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiFischerOA0009#fig1"
    }
  }, [_vm._v("1  Jane Addams, scientist, 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiFischerOA0011#fig2"
    }
  }, [_vm._v("2  Mass meeting at Hull House, 1895")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiFischerOA0012#fig3"
    }
  }, [_vm._v("3  United States troops sent to Chicago, 1894")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiFischerOA0013#fig4"
    }
  }, [_vm._v("4  He Won’t Be Reformed, 1898")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiFischerOA0014#fig5"
    }
  }, [_vm._v("5  Hull House, Pond & Pond, Architects, 1900")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiFischerOA0015#fig6"
    }
  }, [_vm._v("6  Free lectures on organic evolution, 1897")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiFischerOA0016#fig7"
    }
  }, [_vm._v("7  Jane Addams in NCR Women’s Dining Room, May 1898")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d6f526","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Fischer-OA-0008.vue
// module id = 75
// module chunks = 0